import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import Pagination from 'react-js-pagination';
import { requestGet } from '../../api/request';
import { FILMS } from '../../api/url';
import * as actions from '../../redux/actions';
import { ShowFilm, bookFiltersAlph, bookFiltersYear } from '../Partials/Helper';

const Chronicles = () => {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);

  const dictionary = useSelector((state) => state.dictionaryReducer.dictionary);
  const currentLanguage = useSelector(
    (state) => state.languageReducer.current_language,
  );
  const fontSize = useSelector((state) => state.fontSizeReducer.font_size);

  const [data, setData] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchText, setSearchText] = useState(searchParams.get('search') || '');
  const [currentPage, setCurrentPage] = useState(+searchParams.get('page') || undefined);
  const [filterFilm, setFilterFilm] = useState(searchParams.get('filter') || 'year_desc');

  const getData = async () => {
    setLoader(true);
    const response = await requestGet(FILMS, {
      'type': 'chronicles',
      'page': currentPage,
      'searchText': searchText,
      'filter': filterFilm,
    });

    if (response.success) {
      setLoader(false);
      setData(response.data);
    }
  };

  const handleSearchText = (e) => {
    const { target } = e;
    setCurrentPage(1);
    if (target.value !== null && target.value !== '') {
      searchParams.set('search', target.value);
      searchParams.delete('page');
    } else {
      searchParams.delete('search');
    }
    setSearchParams(searchParams);
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 1) {
      searchParams.set('page', +pageNumber);
    } else {
      searchParams.delete('page');
      setCurrentPage(1);
    }
    setSearchParams(searchParams);
  };

  const handleFilterChange = (e) => {
    const { target } = e;
    if (target.value !== 'year_desc') {
      searchParams.set('filter', target.value);
    } else {
      searchParams.delete('filter');
    }
    setSearchParams(searchParams);
  };

  useEffect(() => {
    // Handle page url params;
    if (+searchParams.get('page') > 1) {
      setCurrentPage(+searchParams.get('page'));
    }
    // Handle search url params;
    if (searchParams.get('search')) {
      setSearchText(searchParams.get('search'));
    } else {
      setSearchText('');
    }
    // Handle filter url params;
    if (searchParams.get('filter')) {
      setFilterFilm(searchParams.get('filter'));
    } else {
      setFilterFilm('year_desc');
    }
  }, [searchParams]);

  useEffect(() => {
    if (data) {
      dispatch(actions.adjustFontSize(fontSize));
    }
  });

  useEffect(() => {
    if (searchText) {
      const delayDebounceFn = setTimeout(() => {
        setData([]);
        getData();
      }, 500);
      return () => clearTimeout(delayDebounceFn);
    } else {
      getData();
    }
  }, [currentPage, searchText, filterFilm, currentLanguage]);

  return (
    <div
      className="tab-pane fade show active"
      id="biography"
      role="tabpanel"
      aria-labelledby="biography-tab"
    >
      <div className="row">
        <div className="orders-search col-md-8">
          <div className="search d-lg-block">
            <input
              className="search__input"
              type="text"
              value={searchText}
              onChange={handleSearchText}
              placeholder={dictionary.search}
            />
            <button type="button" className="search-button">
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_1016_9838)">
                  <path
                    d="M25.8333 23.3333H24.5167L24.05 22.8833C25.6833 20.9833 26.6667 18.5167 26.6667 15.8333C26.6667 9.85 21.8167 5 15.8333 5C9.85 5 5 9.85 5 15.8333C5 21.8167 9.85 26.6667 15.8333 26.6667C18.5167 26.6667 20.9833 25.6833 22.8833 24.05L23.3333 24.5167V25.8333L31.6667 34.15L34.15 31.6667L25.8333 23.3333ZM15.8333 23.3333C11.6833 23.3333 8.33333 19.9833 8.33333 15.8333C8.33333 11.6833 11.6833 8.33333 15.8333 8.33333C19.9833 8.33333 23.3333 11.6833 23.3333 15.8333C23.3333 19.9833 19.9833 23.3333 15.8333 23.3333Z"
                    fill="#333333"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1016_9838">
                    <rect
                      width="40"
                      height="40"
                      fill="white"
                      transform="translate(0 0.000244141)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </button>
          </div>
        </div>
        <div className="book_filter col-md-4 d-lg-block">
          <select
            className="form-select-lg form-control mb-3"
            aria-label="select"
            id="sel"
            value={filterFilm}
            onChange={handleFilterChange}
          >
            <optgroup label={dictionary.books_year_filter}>
              {bookFiltersYear.map((option) => (
                <option
                  key={option.value}
                  defaultValue={filterFilm === option.value ? 'selected' : ''}
                  value={option.value}
                >
                  {dictionary[option.label]}
                </option>
              ))}
            </optgroup>
            <optgroup label={dictionary.films_alph_filter}>
              {bookFiltersAlph.map((option) => (
                <option
                  key={option.value}
                  defaultValue={filterFilm === option.value ? 'selected' : ''}
                  value={option.value}
                >
                  {dictionary[option.label]}
                </option>
              ))}
            </optgroup>
          </select>
        </div>
      </div>
      {loader === true ? (
        <div className="row d-flex justify-content-md-center align-items-center mt-3 mb-3">
          <div className="spinner-border text-success" role="status">
            <span className="sr-only" />
          </div>
        </div>
      ) : null}
      {data ? (
        <>
          <div className="row">
            <ShowFilm data={data} />
          </div>
          {data.last_page > 1
            ? (
              <Pagination
                activePage={currentPage || 0}
                totalItemsCount={data.data ? data.total : 0}
                onChange={(pageNumber) => handlePageChange(pageNumber)}
                pageRangeDisplayed={14}
                itemclassName=""
                linkclassName=""
                firstPageText={dictionary.pagination_prev}
                lastPageText={dictionary.pagination_last}
                prevPageText={dictionary.pagination_first}
                nextPageText={dictionary.pagination_next}
                innerClass="paginations d-lg-flex flex-wrap"
                hideDisabled={true}
              />
            ) : null }
        </>
      ) : null}
    </div>
  );
};

export default Chronicles;
